<template>
  <div class='base-info'>
    <a-card title='资质列表' :bordered='false' :headStyle="{paddingLeft:'0px'}">
    </a-card>
    <a-button type='primary' style='margin-top: 20px;margin-bottom: 20px' @click.stop='addEvent'>
      + 添加资质
    </a-button>
    <custom-page-table
      ref='table'
      rowKey='id'
      :columns='columns'
      :requestPromise='loadData'>
      <span slot='action' slot-scope='rowItem'>
        <a @click.stop='onEditEvent(rowItem.record)'>编辑</a>
        <a-divider type='vertical'></a-divider>
        <a v-if='rowItem.record.status===0' @click.stop='switchEvent(rowItem.record)'>显示</a>
        <a v-else @click.stop='switchEvent(rowItem.record)'>隐藏</a>
      </span>
    </custom-page-table>
    <a-modal
      :visible='showDialog'
      @cancel='showDialog=false'
      @ok='submitEvent'
      centered
      width='800px'
      title='添加资质'
    >
      <a-form-model
        ref='ruleForm'
        :model='ruleForm'
        :rules='rules'
        :label-col='{span:4}' :wrapper-col='{span:20}'
      >
        <a-form-model-item label='许可证名称' prop='licenceName'>
          <a-input v-model='ruleForm.licenceName' :maxLength='100' style='width: 300px' placeholder='请输入'>
          </a-input>
        </a-form-model-item>
        <a-form-model-item label='截至日期' prop='selectDate'>
          <a-date-picker
            @change='onDateChange'
            v-model='ruleForm.selectDate'
            style='width: 300px'
            placeholder='请选择'/>

        </a-form-model-item>
        <a-form-model-item label='上传许可证' prop='licenceUrl'>
          <CustomUploadProImages
            :show-flag='false'
            :isProduct='false'
            :max-count='1'
            :show-delete='true'
            v-model='ruleForm.licenceUrl'></CustomUploadProImages>
        </a-form-model-item>
      </a-form-model>


    </a-modal>
  </div>

</template>

<script>

import CustomUploadProImages from '@/customComponents/CustomUploadProImages/CustomUploadProImages.vue'
import DateHelper from '@/utils/helper/dateHelper'

export default {
  name: 'ManageInfoComponents',
  components: {
    CustomUploadProImages
  },
  data() {
    return {
      submitLoading: false,
      showDialog: false,
      ruleForm: {
        licenceDate: '',
        selectDate: undefined,
        licenceName: '',
        licenceUrl: []
      },
      rules: {

        licenceName: [
          { required: true, message: '请输入名称', trigger: ['blur', 'change'] }
        ],
        selectDate: [
          { required: true, message: '请选中截至日期', trigger: ['blur', 'change'] }
        ],
        licenceUrl: [
          { required: true, message: '请上传图片', trigger: ['blur', 'change'] }
        ]
      },

      columns: [
        {
          title: '许可证名称',
          dataIndex: 'licenceName'
        },
        {
          title: '截止日期',
          dataIndex: 'licenceDate'
        },
        {
          title: '状态',
          dataIndex: 'statusStr'
        },
        {
          title: '提交时间',
          dataIndex: 'updateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      loadData: (parameter) => {
        return this.getHttpServices().getUserService().post('merchant/licence/listPage', parameter)
      }
    }
  },
  mounted() {

  },
  methods: {

    onDateChange(date, dateStr) {
      this.ruleForm.licenceDate = dateStr
    },
    onEditEvent(record) {
      const { id, licenceDate, licenceName, licenceUrl } = record
      this.ruleForm = {
        id,
        licenceDate,
        licenceName,
        licenceUrl: licenceUrl ? [licenceUrl] : [],
        selectDate: DateHelper.getMoment(licenceDate)
      }
      this.showDialog = true
    },
    addEvent() {
      this.ruleForm = {}
      this.showDialog = true
    },
    switchEvent(record) {
      const { id, status } = record
      this.getHttpServices().getUserService().post('merchant/licence/updateStatus', { id })
        .then(res => {
          this.$message.success('设置成功')
          this.showDialog = false
          this.$refs.table.refresh(false)
        })
        .catch(reason => {
          const tips = '设置失败,请重试！'
          const msg = reason && reason.msg ? reason.msg : tips
          this.$message.success(msg)
        })
    },
    submitEvent() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.requestSubmit()
        } else {
          this.$message.error('请完善表单信息')
        }
      })
    },
    requestSubmit() {
      const { licenceDate, licenceName, licenceUrl, id } = this.ruleForm
      const params = {
        licenceDate,
        licenceName,
        id,
        licenceUrl: licenceUrl[0]
      }
      const url = id ? 'merchant/licence/update' : 'merchant/licence/add'
      this.getHttpServices().getUserService().post(url, params)
        .then(res => {
          this.$message.success(id ? '编辑成功' : '保存成功')
          this.showDialog = false
          this.$refs.table.refresh(!id)
        })
        .catch(reason => {
          const tips = id ? '编辑失败,请重试！' : '保存失败,请重试'
          const msg = reason && reason.msg ? reason.msg : tips
          this.$message.success(msg)
        })
    }
  }
}
</script>
<style lang='less'>
@import "./baseInfo";
</style>